function _isStaging() {
  console.log(window.location.toString());
  return window.location.toString().includes(".webflow.io");
}

export const isStaging = _isStaging();
//export const isStaging = _isStaging();
